import { Cloud } from '@cast/shared-types';
import { PermissionsCenterCloud } from '@cast/types-permissions-center';

import { SupportedCloudProvider } from './types';

export const SUPPORTED_CLOUD_PROVIDERS = [
  Cloud.aws,
  Cloud.azure,
  Cloud.gcp,
  Cloud.oracle,
] as const;

export const DEFAULT_CLOUD_PROVIDER = Cloud.aws;

export const SUPPORTED_CLOUD_TO_PERMISSIONS_CENTER_CLOUD: Record<
  SupportedCloudProvider,
  PermissionsCenterCloud
> = {
  [Cloud.aws]: 'AWS',
  [Cloud.azure]: 'AZURE',
  [Cloud.gcp]: 'GCP',
  [Cloud.oracle]: 'ORACLE',
};
